import { useState, useEffect } from "react";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

function BioSection({ bio = "" }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const shouldTruncate = isMobile && bio.length > 150;
  const truncatedText = shouldTruncate ? `${bio.substring(0, 150)}...` : bio;
  const displayText = isExpanded ? bio : truncatedText;

  return (
    <div id="bio" className="profile-content__section">
      <div className="profile-content__title">Bio</div>

      <div className="profile-content__text">
        {displayText}
        {shouldTruncate && (
          <button type="button" className="bio-see-more" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? "see less" : "see more"}
          </button>
        )}
      </div>
    </div>
  );
}

export default BioSection;
